import React from 'react'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { NavLink } from 'react-router-dom';
  
  function createData(name: string, INN: string, document: string, date: string) {
    return { name, INN, document, date };
  }
  
  const salary = [
    createData('Абдышев Азамат Нурланович', '123456789123', 'Справка о доходах', '21 октября 2019')
  ];

const SalaryTable = () => {

    return (
        <TableContainer component={Paper}>
            <Table aria-label="simple table">
                <TableHead>
                <TableRow>
                    <TableCell align="left">№</TableCell>
                    <TableCell>Клиент</TableCell>
                    <TableCell align="center">ИНН</TableCell>
                    <TableCell align="center">Документ</TableCell>
                    <TableCell align="center">Дата</TableCell>
                    <TableCell align="center">Действие</TableCell>
                </TableRow>
                </TableHead>
                <TableBody>
                {salary.map((sale, index) => (
                    <TableRow key={index}>
                        <TableCell align="left">{index + 1}</TableCell>
                        <TableCell component="th" scope="row">{sale.name}</TableCell>
                        <TableCell align="center">{sale.INN}</TableCell>
                        <TableCell align="center">{sale.document}</TableCell>
                        <TableCell align="center">{sale.date}</TableCell>
                        <TableCell align="center">
                            <NavLink to="/income">Документ</NavLink>
                        </TableCell>
                    </TableRow>
                ))}
                </TableBody>
            </Table>
        </TableContainer>
    )
}

export default SalaryTable